module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-00.7087aafa.png";